import {
  ChevronUp,
  Info,
  PlusCircle,
} from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { setToogleHeader } from "../../../core/redux/action";
import apiHandler from "../../common/api";
import "sweetalert2/dist/sweetalert2.min.css";
import { setTeamValue } from "../../../core/redux/action";
// import config from "../../../config";
import { Country, State, City } from "country-state-city";
import { Imageurl, NoImage } from "../../../config";
// import moment from "moment";
import { imgpathgenerator } from "../../../core/Common/imgpathgenerator";
import { isValidAustralianPhoneNumber } from "../../common/common";

const AddTeam = ({
  isDisable = false,
  staffId,
  handleChangeFile,  // ✅ must match what we send from parent
  isFromOnboarding = 0,
}) => {
  console.log(isDisable, "isDisableisDisable123");
  const dispatch = useDispatch();
  const location = useLocation();
  const parts = location.pathname;
  let pathname = parts?.trim()?.split("/");
  const data = useSelector((state) => state.toggle_header);
  const formValue = useSelector((state) => state.TeamValue);
  const [colorOption, setcoloroption] = useState([]);
  const [roleData, setroledata] = useState([]);
  // const [isEmialChange, setIsEmailChange] = useState(0);
  // const isEmialChange = 0;
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );
  const [showPassword, setShowPassword] = useState(false);

  console.log(formValue, "check form value formValue");
  console.log(handleChangeFile, "check form value handleChangeFile");

  const handleTogglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const [showConfirmPassword, setConfirmPassword] = useState(false);
  const handleToggleConfirmPassword = () => {
    setConfirmPassword((prevShowPassword) => !prevShowPassword);
  };

  const allCountries = Country.getAllCountries();
  const [options, setOptions] = useState({
    gender: [],
    countries: allCountries.map((c) => ({
      value: c.name,
      label: c.name,
    })),
  });

  useEffect(() => {
    if (formValue.Country) {
      const statesData = State.getStatesOfCountry(
        allCountries.find((c) => c.name === formValue.Country)?.isoCode
      );
      setOptions((prev) => ({
        ...prev,
        states: statesData.map((s) => ({
          value: s.name,
          label: s.name,
        })),
      }));

      // If editing with a pre-filled state, fetch cities right away
      if (formValue.State) {
        const cities = City.getCitiesOfState(
          allCountries.find((c) => c.name === formValue.Country)?.isoCode,
          statesData.find((s) => s.name === formValue.State)?.isoCode
        );

        setOptions((prev) => ({
          ...prev,
          cities: cities.map((c) => ({
            value: c.name,
            label: c.name,
          })),
        }));
      }
    }
  }, [formValue.Country, formValue.State]);

  const prodcutDataListApi = async () => {
    const response = await apiHandler({
      method: "GET",
      route: `Superadmin/addTeamAll`,
    });

    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      let colordata = response?.ResponseData[0]?.map((u) => ({
        label: u.colorCode,
        value: u.ID,
      }));
      setcoloroption(colordata);

      let Roledata = response?.ResponseData[1]?.map((u) => ({
        label: u.roleName,
        value: u.id,
      }));
      setroledata(Roledata);
    } else {
      console.log(response, "data");
    }
  };

  useEffect(() => {
    prodcutDataListApi();
  }, []);

  const Handlefile = (e) => {
    let file = e.target.files[0];

    if (!file) return;

    const fileUrl = URL.createObjectURL(file);
    // const profilePath = `assets/${pathname[1]}/${moment().year()}/${
    //   moment().month() + 1
    // }/${encodeURIComponent(file.name)}`;

    // Store only serializable data in Redux
    dispatch(
      setTeamValue({
        ...formValue,
        profile: imgpathgenerator(file.name, pathname[1]) || "",
        uniquefileName:
          JSON.stringify([imgpathgenerator(file.name, pathname[1])]) || "[]",
        prevProfile: fileUrl,
        dirname: pathname[1],
        fileName: file.name, // Store name instead of full file
        fileType: file.type, // Store type if needed
      })
    );

    handleChangeFile(file);
  };

  console.log(formValue, "formValueformValue123");

  // const HandleChange = (e) => {
  //   const { name, value } = e.target;
  //   dispatch(setTeamValue({ ...formValue, [name]: value }));
  // };

  const HandleChange = (e) => {
    const { name, value } = e.target;

    console.log(name, "check name of input");

    if (name == "Email") {
      dispatch(setTeamValue({ ...formValue, Email: value, isEmialChange: 1 }));
      return;
    }

    let newValue = value;

    if (name === "ContactNumber") {
      // keep only digits and +
      let digits = value.replace(/[^\d+]/g, "");

      // ensure it starts with +61
      if (digits.startsWith("0")) {
        digits = "+61" + digits.slice(1);
      } else if (!digits.startsWith("+61")) {
        digits = "+61" + digits.replace(/^\+?61/, "");
      }

      // remove any non-digits except +
      digits = "+" + digits.replace(/[^\d]/g, "").slice(0, 11); // + plus 11 digits

      // formatting for UI (spaces)
      let formatted = digits;
      if (digits.length >= 3) {
        if (digits[2] === "4") {
          // Mobile: +61 4XX XXX XXX
          formatted = `${digits.slice(0, 3)} ${digits.slice(
            3,
            4
          )} ${digits.slice(4, 8)} ${digits.slice(8)}`;
        } else {
          // Landline: +61 X XXXX XXXX
          formatted = `${digits.slice(0, 3)} ${digits.slice(
            3,
            4
          )} ${digits.slice(4, 8)} ${digits.slice(8)}`;
        }
      }

      newValue = formatted;
    }

    dispatch(setTeamValue({ ...formValue, [name]: newValue }));
  };

  const Handleselect = (e, label) => {
    if (label == "RoleID") {
      dispatch(
        setTeamValue({
          ...formValue,
          [label]: e.value,
        })
      );
    }
  };

  const HandleCountryselect = (e, label) => {
    if (label == "Country") {
      dispatch(
        setTeamValue({
          ...formValue,
          [label]: e.value,
        })
      );
    }
  };

  const handleColorClick = (color, ID) => {
    dispatch(
      setTeamValue({
        ...formValue,
        CalendorColorID: ID,
      })
    );
    console.log(ID, "Verify ID");
  };

  const TeamValue = useSelector((state) => state.TeamValue);
  console.log(TeamValue, "TeamValue100000");
  const addContact = (e) => {
    e.preventDefault();
    const newContacts = [
      ...(TeamValue?.EmergencyContact || []),
      { Id: 0, fullName: "", email: "", relationship: "", phoneNumber: "" },
    ];
    dispatch(setTeamValue({ ...TeamValue, EmergencyContact: newContacts }));
  };

  // const handleChange = (index, field, value) => {
  //   if (!TeamValue?.EmergencyContact) return;

  //   const newContacts = [...TeamValue.EmergencyContact];
  //   newContacts[index] = { ...newContacts[index], [field]: value };

  //   dispatch(setTeamValue({ ...TeamValue, EmergencyContact: newContacts }));
  // };

  const handleChange = (index, field, value) => {
    if (!TeamValue?.EmergencyContact) return;

    const newContacts = [...TeamValue.EmergencyContact];
    let updatedValue = value;

    if (field === "phoneNumber") {
      // Allow only digits and +
      let digits = value.replace(/[^\d+]/g, "");

      // Ensure +61 prefix
      if (digits.startsWith("0")) {
        digits = "+61" + digits.slice(1);
      } else if (!digits.startsWith("+61")) {
        digits = "+61" + digits.replace(/^\+?61/, "");
      }

      // Keep only 9 digits after +61
      digits = "+61" + digits.slice(3).replace(/\D/g, "").slice(0, 9);

      // Format for UI
      let formatted = digits;
      if (digits.length >= 3) {
        if (digits[3] === "4") {
          // Mobile: +61 4XX XXX XXX
          formatted = `${digits.slice(0, 3)} ${digits.slice(
            3,
            5
          )} ${digits.slice(5, 8)} ${digits.slice(8)}`;
        } else {
          // Landline: +61 X XXXX XXXX
          formatted = `${digits.slice(0, 3)} ${digits.slice(
            3,
            4
          )} ${digits.slice(4, 8)} ${digits.slice(8)}`;
        }
      }

      updatedValue = formatted.trim();
    }

    newContacts[index] = { ...newContacts[index], [field]: updatedValue };

    dispatch(setTeamValue({ ...TeamValue, EmergencyContact: newContacts }));
  };

  const removeContact = (index) => {
    const newContacts = TeamValue?.EmergencyContact.filter(
      (_, i) => i !== index
    );
    dispatch(setTeamValue({ ...TeamValue, EmergencyContact: newContacts }));
  };

  const handleCheckboxChange = (event, serviceId, PriceID) => {
    const isChecked = event.target.checked;
    let updatedata = [...TeamValue.Serviceandcommision];
    let index = updatedata?.findIndex(
      (el) => el.serviceId == serviceId && el.PriceID == PriceID
    );
    updatedata[index] = {
      ...updatedata[index],
      ["Ischecked"]: isChecked,
    };
    dispatch(
      setTeamValue({
        ...TeamValue,
        Serviceandcommision: updatedata,
      })
    );
  };

  const handleCommissionChange = (event, serviceId, PriceID) => {
    const commission = event.target.value;
    let updatedata = [...TeamValue.Serviceandcommision];
    let index = updatedata?.findIndex(
      (el) => el.serviceId == serviceId && el.PriceID == PriceID
    );
    updatedata[index] = {
      ...updatedata[index],
      ["commission"]: commission,
      ["Ischecked"]: true,
    };
    dispatch(
      setTeamValue({
        ...TeamValue,
        Serviceandcommision: updatedata,
      })
    );
  };

  const handleHomeServiceChange = (event, serviceId, PriceID) => {
    const commission = event.target.value;
    let updatedata = [...TeamValue.Serviceandcommision];
    let index = updatedata?.findIndex(
      (el) => el.serviceId == serviceId && el.PriceID == PriceID
    );
    updatedata[index] = {
      ...updatedata[index],
      ["homeServicePrice"]: commission,
      ["Ischecked"]: true,
    };
    dispatch(
      setTeamValue({
        ...TeamValue,
        Serviceandcommision: updatedata,
      })
    );
  };

  const handleCancel = () => {
    dispatch(
      setTeamValue({
        ...formValue,
        profile: "",
        prevProfile: "",
        fileName: "",
        fileType: "",
      })
    );
    handleChangeFile(null);
  };

  const formatDBPhoneNumber = (number) => {
    if (!number) return "";

    // Ensure it starts with +61
    let cleaned = number.replace(/\D/g, ""); // remove non-digits
    if (cleaned.startsWith("61")) {
      cleaned = "+" + cleaned;
    } else if (cleaned.startsWith("0")) {
      cleaned = "+61" + cleaned.substring(1);
    } else if (!cleaned.startsWith("+61")) {
      cleaned = "+61" + cleaned;
    }

    // Remove + for formatting spaces, but keep for final output
    const noPlus = cleaned.replace("+", "");

    // Format: +61 4 1234 5678
    return "+" + noPlus.replace(/^61(\d)(\d{4})(\d{4})$/, "61 $1 $2 $3");
  };

  console.log(formValue, "formValue 1230000xdsxds");
  console.log(TeamValue?.Serviceandcommision, "home service checkprice");

  return (
    <div className={isFromOnboarding == 1 ? "" : "mt-5"}>
      <div className={isFromOnboarding == 1 ? "" : "page-wrapper  pt-0"}>
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>New Employee</h4>
                <h6>Create new Employee</h6>
              </div>
            </div>

            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
          {/* /product list */}
          <form>
            {/* Old Code Place If You Want To Revort Code Add here Old Code Save In NotePad File new238 */}

            <div className="card">
              <div className="card-body add-product pb-0">
                <div className="accordion" id="accordionPanelsStayOpenExample">
                  <div className="accordion-item">
                    <h2
                      className="accordion-header"
                      id="panelsStayOpen-headingOne"
                    >
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseOne"
                        aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseOne"
                      >
                        <div className="card-title-head">
                          <h6 className="m-0 p-0" style={{ border: "none" }}>
                            <span>
                              <Info className="feather-edit" />
                            </span>
                            Employee Information
                          </h6>
                        </div>
                      </button>
                    </h2>
                    <div
                      id="panelsStayOpen-collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="panelsStayOpen-headingOne"
                    >
                      <div className="accordion-body">
                        {/* <div className="mb-3">
                          <label className="form-label">Profile</label>
                          <div>
                            <img
                              src={
                                formValue?.prevProfile
                                  ? formValue?.prevProfile
                                  : formValue?.profile
                                  ? Imageurl + formValue?.profile
                                  : NoImage
                              }
                              alt="Uploaded Image"
                              height="100px"
                              width="100px"
                            />
                          </div>
                          {isDisable == false && (
                            // <div className="profile-pic">
                            <input
                              type="file"
                              name="profile"
                              className="form-control"
                              onChange={Handlefile}
                            />
                            // </div>
                          )}

                          {/* <div className="input-blocks mb-0">
                            <div className="image-upload mb-0">
                              <input type="file" />
                              <div className="image-uploads">
                                <h4>Change Image</h4>
                              </div>
                            </div>
                          </div> 
                        </div> */}

                        <div className="row">
                          <div className="container my-3">
                            <div className="card custome-card-padding rounded-2 mb-0">
                              <div className="row align-items-center">
                                {/* Image Preview */}
                                <div className="col-auto">
                                  <input
                                    type="file"
                                    name="profile"
                                    className="d-none"
                                    ref={(input) =>
                                      (window.employeeProfileInput = input)
                                    }
                                    onChange={Handlefile}
                                  />
                                  <img
                                    src={
                                      formValue?.prevProfile
                                        ? formValue.prevProfile
                                        : formValue?.profile
                                        ? Imageurl + formValue.profile
                                        : NoImage
                                    }
                                    alt="Employee"
                                    className="custome-image rounded-circle"
                                    width="80"
                                    height="80"
                                    style={{
                                      objectFit: "cover",
                                      cursor: isDisable ? "default" : "pointer",
                                    }}
                                    onClick={() => {
                                      if (
                                        !isDisable &&
                                        window.employeeProfileInput
                                      ) {
                                        window.employeeProfileInput.click();
                                      }
                                    }}
                                    onError={(e) => {
                                      e.currentTarget.src =
                                        "https://mock.sonarpos.com/static/media/noimage.4ab3885dec12ad76c627.png";
                                    }}
                                  />
                                </div>

                                {/* Label and Info */}
                                <div className="col-auto">
                                  <h6 className="mb-0 fw-bold">
                                    Upload Employee Image
                                  </h6>
                                  <small className="text-color-70">
                                    Image should be below 500 kb
                                  </small>
                                </div>

                                {/* Cancel Button */}
                                {!isDisable && (
                                  <div className="col-auto d-flex gap-3 ms-auto">
                                    <button
                                      type="button"
                                      className="btn btn-outline-primary btn-sm"
                                      onClick={handleCancel}
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4 col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Full Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="FirstName"
                                value={formValue.FirstName}
                                onChange={HandleChange}
                                disabled={isDisable}
                              />
                            </div>
                          </div>

                          <div className="col-lg-4 col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Email <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="Email"
                                value={formValue.Email}
                                onChange={HandleChange}
                                disabled={isDisable}
                                autoComplete={"off"}
                              />
                            </div>
                          </div>

                          <div className="col-lg-4 col-md-6">
                            <label className="form-label">
                              Password
                              {staffId == 0 && (
                                <span style={{ color: "red" }}>*</span>
                              )}
                            </label>
                            <div className="pass-group">
                              <input
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                placeholder="Enter your password"
                                name="PassWord"
                                value={formValue?.PassWord}
                                // value={
                                //   formValue?.PassWord.length > 8
                                //     ? "******"
                                //     : formValue?.PassWord
                                // }
                                onChange={HandleChange}
                                disabled={isDisable}
                                // autoComplete="off"
                                autoComplete="new-password"
                              />
                              <span
                                className={`fas toggle-password ${
                                  showPassword ? "fa-eye" : "fa-eye-slash"
                                }`}
                                onClick={handleTogglePassword}
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-6">
                            <label className="form-label">
                              Confirm Password{" "}
                              {staffId == 0 && (
                                <span style={{ color: "red" }}>*</span>
                              )}
                            </label>
                            <div className="pass-group">
                              <input
                                type={showConfirmPassword ? "text" : "password"}
                                className="form-control"
                                placeholder="Enter your password"
                                name="ConformPassword"
                                value={formValue?.ConformPassword}
                                // value={
                                //   formValue.ConformPassword.length > 8
                                //     ? "******"
                                //     : formValue.ConformPassword
                                // }
                                onChange={HandleChange}
                                disabled={isDisable}
                              />
                              <span
                                className={`fas toggle-password ${
                                  showConfirmPassword
                                    ? "fa-eye"
                                    : "fa-eye-slash"
                                }`}
                                onClick={handleToggleConfirmPassword}
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Contact Number {"(Optional)"}
                              </label>
                              <input
                                type="text" // allow + and spaces
                                className="form-control"
                                name="ContactNumber"
                                value={
                                  formatDBPhoneNumber(
                                    formValue.ContactNumber
                                  ) || ""
                                } // format for UI
                                onChange={HandleChange}
                                disabled={isDisable}
                                placeholder="Add Number After +61"
                                onBlur={() => {
                                  // store clean number without spaces for DB
                                  const rawNumber = formValue.ContactNumber
                                    ? formValue.ContactNumber.replace(
                                        /\s+/g,
                                        ""
                                      )
                                    : "";

                                  if (
                                    rawNumber &&
                                    !isValidAustralianPhoneNumber(rawNumber)
                                  ) {
                                    dispatch(
                                      setTeamValue({
                                        ...formValue,
                                        ContactNumber: rawNumber, // save cleaned version
                                        ContactNumberError:
                                          "Please enter a valid Australian number (e.g., +61 4XX XXX XXX).",
                                      })
                                    );
                                  } else {
                                    dispatch(
                                      setTeamValue({
                                        ...formValue,
                                        ContactNumber: rawNumber, // save cleaned version
                                        ContactNumberError: "",
                                      })
                                    );
                                  }
                                }}
                              />
                              {formValue.ContactNumberError && (
                                <span className="text-danger">
                                  {formValue.ContactNumberError}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-4 col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Designation{" "}
                                {/* <span style={{ color: "red" }}>*</span> */}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="designation"
                                value={formValue.designation}
                                onChange={HandleChange}
                                disabled={isDisable}
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Role ID <span style={{ color: "red" }}>*</span>
                              </label>

                              <Select
                                classNamePrefix="react-select"
                                options={roleData}
                                placeholder="Choose"
                                name="RoleID"
                                value={roleData?.find(
                                  (el) => el.value == formValue.RoleID
                                )}
                                onChange={(e) => Handleselect(e, "RoleID")}
                                isDisabled={isDisable}
                              />
                            </div>
                          </div>
                          <div className="col-lg-8 col-md-12">
                            <div className="mb-3">
                              <label className="form-label">
                                Calendar color {"(Optional)"}
                              </label>
                              <div
                                className={`d-flex flex-wrap gap-2 ${
                                  isDisable ? "disabled" : ""
                                }`}
                                style={{
                                  pointerEvents: isDisable ? "none" : "auto",
                                  opacity: isDisable ? 0.5 : 1,
                                }}
                              >
                                {colorOption.map((color) => (
                                  <div
                                    key={color}
                                    className={`caledor-color ${
                                      formValue?.CalendorColorID ===
                                      color?.value
                                        ? "active"
                                        : ""
                                    }`}
                                    style={{ backgroundColor: color?.label }}
                                    onClick={
                                      !isDisable
                                        ? () =>
                                            handleColorClick(
                                              color,
                                              color?.value
                                            )
                                        : undefined
                                    }
                                  ></div>
                                ))}
                              </div>
                            </div>
                          </div>
                          {/* <div className="col-lg-12 col-md-12 col-12">
                            <div className="mb-3">
                              <div className="d-flex justify-content-end">
                                <button className="btn btn-secondary">
                                  Save
                                </button>
                              </div>
                            </div>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2
                      className="accordion-header"
                      id="panelsStayOpen-headingTwo"
                    >
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseTwo"
                        aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseTwo"
                      >
                        <div className="card-title-head">
                          <h6 className="m-0 p-0" style={{ border: "none" }}>
                            <span>
                              <Info className="feather-edit" />
                            </span>
                            Other Information {"(Optional)"}
                          </h6>
                        </div>
                      </button>
                    </h2>
                    <div
                      id="panelsStayOpen-collapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingTwo"
                    >
                      <div className="accordion-body">
                        <div className="row">
                          <div className="col-lg-4 col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Address1</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Address1"
                                value={formValue.Address1}
                                onChange={HandleChange}
                                disabled={isDisable}
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Address2</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Address2"
                                value={formValue.Address2}
                                onChange={HandleChange}
                                disabled={isDisable}
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Country</label>

                              <Select
                                classNamePrefix="react-select"
                                options={options?.countries}
                                placeholder="Select"
                                name="Country"
                                value={options?.countries?.find(
                                  (el) => el.value == formValue.Country
                                )}
                                onChange={(e) =>
                                  HandleCountryselect(e, "Country")
                                }
                                isDisabled={isDisable}
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-6">
                            <div className="mb-3">
                              <label className="form-label">State</label>
                              <Select
                                classNamePrefix="react-select"
                                options={options?.states}
                                name="state"
                                value={options?.states?.find(
                                  (el) => el.value == formValue.State
                                )}
                                onChange={(e) =>
                                  HandleChange({
                                    target: {
                                      value: e ? e?.value : "",
                                      name: "State",
                                    },
                                  })
                                }
                                placeholder="Choose State"
                                isDisabled={
                                  isDisable ? isDisable : !formValue.Country
                                }
                              />
                              {/* <input
                                type="text"
                                className="form-control"
                                name="State"
                                value={formValue.State}
                                onChange={HandleChange}
                                disabled={isDisable}
                              /> */}
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-6">
                            <div className="mb-3">
                              <label className="form-label">City</label>
                              <Select
                                classNamePrefix="react-select"
                                options={options?.cities}
                                name="City"
                                value={options?.cities?.find(
                                  (el) => el.value == formValue.City
                                )}
                                onChange={(e) =>
                                  HandleChange({
                                    target: {
                                      value: e ? e?.value : "",
                                      name: "City",
                                    },
                                  })
                                }
                                placeholder="Choose City"
                                isDisabled={
                                  isDisable ? isDisable : !formValue.State
                                }
                              />
                              {/* <input
                                type="text"
                                className="form-control"
                                name="City"
                                value={formValue.City}
                                onChange={HandleChange}
                                disabled={isDisable}
                              /> */}
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Zipcode</label>
                              <input
                                type="text"
                                className="form-control"
                                name="ZipCode"
                                value={formValue.ZipCode}
                                onChange={HandleChange}
                                disabled={isDisable}
                              />
                            </div>
                          </div>
                          {/* <div className="col-lg-12 col-md-12 col-12">
                            <div className="mb-3">
                              <div className="d-flex justify-content-end">
                                <button className="btn btn-secondary">
                                  Save
                                </button>
                              </div>
                            </div>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2
                      className="accordion-header"
                      id="panelsStayOpen-headingThree"
                    >
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseThree"
                        aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseThree"
                      >
                        <div className="card-title-head">
                          <h6 className="m-0 p-0" style={{ border: "none" }}>
                            <span>
                              <Info className="feather-edit" />
                            </span>
                            Emergency Contact Information {"(Optional)"}
                          </h6>
                        </div>
                      </button>
                    </h2>
                    <div
                      id="panelsStayOpen-collapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingThree"
                    >
                      <div className="accordion-body">
                        <form>
                          <div className="card">
                            <div className="card-body">
                              {isDisable == false && (
                                <div className="new-employee-field">
                                  <div className="card-title-head">
                                    <h6>Add Emergency Contact Here</h6>
                                  </div>

                                  <button
                                    className="btn btn-primary btn-sm me-2"
                                    onClick={(e) => addContact(e)}
                                  >
                                    <PlusCircle className="plus-down-add" /> Add
                                    emergency contact
                                  </button>
                                </div>
                              )}

                              {TeamValue?.EmergencyContact?.map(
                                (contact, index) => (
                                  <div key={index} className="contact-form">
                                    <div className="row mt-3 mb-3">
                                      <div className="col-lg-3 col-md-6">
                                        <input
                                          type="text"
                                          placeholder="Full Name"
                                          value={contact.fullName}
                                          onChange={(e) =>
                                            handleChange(
                                              index,
                                              "fullName",
                                              e.target.value
                                            )
                                          }
                                          className="form-control"
                                          disabled={isDisable}
                                        />
                                      </div>
                                      <div className="col-lg-3 col-md-6">
                                        <input
                                          type="email"
                                          placeholder="Email"
                                          value={contact.email}
                                          onChange={(e) =>
                                            handleChange(
                                              index,
                                              "email",
                                              e.target.value
                                            )
                                          }
                                          className="form-control"
                                          disabled={isDisable}
                                        />
                                      </div>
                                      <div className="col-lg-3 col-md-6">
                                        <select
                                          value={contact.relationship}
                                          onChange={(e) =>
                                            handleChange(
                                              index,
                                              "relationship",
                                              e.target.value
                                            )
                                          }
                                          className="form-control"
                                        >
                                          <option value="">
                                            Select Relationship
                                          </option>
                                          <option value="Family">Family</option>
                                          <option value="Friend">Friend</option>
                                          <option value="Colleague">
                                            Colleague
                                          </option>
                                        </select>
                                      </div>
                                      <div className="col-lg-3 col-md-6">
                                        <input
                                          type="text"
                                          placeholder="Phone Number"
                                          value={
                                            formatDBPhoneNumber(
                                              contact.phoneNumber
                                            ) || ""
                                          }
                                          onChange={(e) => {
                                            // Allow only +, digits, spaces
                                            const value = e.target.value;
                                            if (/^[+\d\s]*$/.test(value)) {
                                              handleChange(
                                                index,
                                                "phoneNumber",
                                                value
                                              );
                                            }
                                          }}
                                          onBlur={() => {
                                            const rawNumber =
                                              contact.phoneNumber
                                                ? contact.phoneNumber.replace(
                                                    /\s+/g,
                                                    ""
                                                  )
                                                : "";

                                            if (
                                              rawNumber &&
                                              !isValidAustralianPhoneNumber(
                                                rawNumber
                                              )
                                            ) {
                                              handleChange(
                                                index,
                                                "phoneNumber",
                                                rawNumber
                                              ); // save cleaned
                                              handleChange(
                                                index,
                                                "phoneNumberError",
                                                "Please enter a valid Australian number (e.g., +61 4XX XXX XXX)."
                                              );
                                            } else {
                                              handleChange(
                                                index,
                                                "phoneNumber",
                                                rawNumber
                                              );
                                              handleChange(
                                                index,
                                                "phoneNumberError",
                                                ""
                                              );
                                            }
                                          }}
                                          className="form-control"
                                        />
                                        {contact.phoneNumberError && (
                                          <small className="text-danger">
                                            {contact.phoneNumberError}
                                          </small>
                                        )}
                                      </div>
                                    </div>
                                    {isDisable == false && (
                                      <div className="col-lg-3 col-md-6">
                                        <Link
                                          style={{
                                            border: "1px solid",
                                            padding: "6px",
                                            borderRadius: "8px",
                                          }}
                                          type="button"
                                          onClick={() => removeContact(index)}
                                        >
                                          Remove
                                        </Link>
                                      </div>
                                    )}
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2
                      className="accordion-header"
                      id="panelsStayOpen-headingFour"
                    >
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseFour"
                        aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseFour"
                      >
                        <div className="card-title-head">
                          <h6 className="m-0 p-0" style={{ border: "none" }}>
                            <span>
                              <Info className="feather-edit" />
                            </span>
                            Service {"(Optional)"}
                          </h6>
                        </div>
                      </button>
                    </h2>
                    <div
                      id="panelsStayOpen-collapseFour"
                      className="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingFour"
                    >
                      <div className="accordion-body">
                        {[
                          ...new Set(
                            TeamValue?.Serviceandcommision?.map(
                              (item) => item.category
                            )
                          ),
                        ]?.map((el, index) => (
                          <div className="row mb-4" key={index}>
                            <div className="col-12">
                              <h6 className="mb-2">{el}</h6>
                              {TeamValue?.Serviceandcommision?.filter(
                                (service) => service.category === el
                              ).map((service, idx) => (
                                <div className="card mb-3" key={idx}>
                                  <div className="card-body">
                                    <div className="row align-items-center">
                                      <div className="col-12 col-md-6 d-flex align-items-center">
                                        <div className="form-check me-3">
                                          <input
                                            type="checkbox"
                                            className="custome-border form-check-input"
                                            id={`service-${service.serviceId}`}
                                            checked={service.Ischecked}
                                            onChange={(e) =>
                                              handleCheckboxChange(
                                                e,
                                                service.serviceId,
                                                service.PriceID
                                              )
                                            }
                                            disabled={isDisable}
                                          />
                                        </div>
                                        <div>
                                          <label
                                            style={{ fontSize: "14px" }}
                                            className="fw-bold form-check-label text-color-70"
                                            htmlFor={`service-${service.serviceId}`}
                                          >
                                            {service.name}
                                          </label>
                                          {service.duration && (
                                            <small
                                              style={{ fontSize: "14px" }}
                                              className="text-muted d-block text-color-70"
                                            >
                                              {service.duration}
                                            </small>
                                          )}
                                        </div>
                                      </div>

                                      <div className="col-12 col-md-2 text-color-70 text-md-end">
                                        <span style={{ fontSize: "14px" }}>
                                          {service?.priceType}{" "}
                                          {service?.priceType ? "-" : ""}{" "}
                                          {Number(service.price).toFixed(2)}
                                        </span>
                                      </div>

                                      <div className="col-12 col-md-2 mt-3 mt-md-0">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Add Service Commission"
                                          value={service?.commission}
                                          onChange={(e) =>
                                            handleCommissionChange(
                                              e,
                                              service.serviceId,
                                              service.PriceID
                                            )
                                          }
                                          disabled={isDisable}
                                        />
                                      </div>

                                      <div className="col-12 col-md-2 mt-3 mt-md-0">
                                        {service?.isThisHomeService === 1 && (
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Home Service"
                                            value={service?.homeServicePrice}
                                            onChange={(e) =>
                                              handleHomeServiceChange(
                                                e,
                                                service.serviceId,
                                                service.PriceID
                                              )
                                            }
                                            disabled={isDisable}
                                          />
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddTeam;
